<template>
  <div id="content" v-if="!loading">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link
              :to="{ name: moduleName }"
              class="btn btn_back"
              v-translate>Seznam
          </router-link>
        </p>
        <h1 v-translate>Přidat přesměrování aplikace</h1>
      </div>
      <div class="responsiveTabs r-tabs">
        <div class="tabs_content" >
          <basic-info
              :entity="entity"
              :editable="$_createActionAllowed"
              :isUpdate="false"
          />
        </div>

        <section class="buttons">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
            <input
                type="submit"
                v-if="$_createActionAllowed"
                :value="'Uložit' | translate"
                :class="['btn', { btn_inactive: !formIsValid }]"
                @click.prevent.stop="createEntity()">
          </p>
        </section>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import versionRedirects from "./mixins/versionRedirects";
import BasicInfo from "./forms/BasicInfo";

export default {
  name: "VersionRedirectNew",
  components: {
    BasicInfo
  },
  mixins: [detailActions, versionRedirects],
  data() {
    return {
    }
  },
  created(VersionRedirectService) {
    this.entityService = VersionRedirectService
    this.loading=false;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/versionRedirect/VersionRedirectNew.vue